























import { PropType } from 'vue';
import { IAiStream } from '../types';
import { fmtTime, parseUtcMs } from '../utils';
import { COLOR_STREAMER_FALLBACK } from '../constants';
import LangChip from './LangChip.vue';

export default {
  name: 'CalendarEventCard',
  components: { LangChip },
  props: {
    stream: {
      type: Object as PropType<IAiStream>,
      required: true
    },
    color: { type: String, default: COLOR_STREAMER_FALLBACK },
    short: { type: Boolean, default: false },
    nowUtc: { type: String, default: '' },
    overlapping: { type: Boolean, default: false }
  },
  computed: {
    gameNames(): string {
      return this.stream.supportedGames.map(({ name }) => name).join(', ');
    },
    isPast(): boolean {
      if (!this.stream?.endTime || !this.nowUtc) return false;
      return parseUtcMs(this.stream.endTime) <= parseUtcMs(this.nowUtc);
    }
  },
  methods: {
    fmtTime
  }
};
